import { request } from "@/common/api";
import { Loading } from "@/components/atoms/Loading";
import { useQuery } from "@tanstack/react-query";
import { AlertText } from "@/components/atoms/AlertText";
import { useNavigate } from "react-router";
import { CommentList } from "@/components/molecules/CommentList";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { useRecoilValue } from "recoil";
import { loginTypeState } from "@/common/states/user";
import { FloatingButton } from "@/components/atoms/Buttons/FloatingButton";
import { GET_CHEER_MESSAGES } from "@/common/querykeys";
import { StudentCheerMessage } from "@/common/types/cheerMessage";
import { ReactComponent as IconWrite } from "@/styles/assets/svg/icon_write.svg";

export const CommentPage = () => {
  const navigate = useNavigate();
  const loginType = useRecoilValue(loginTypeState);

  const { data: cheerMessages, isFetching } = useQuery<StudentCheerMessage[]>({
    queryKey: [GET_CHEER_MESSAGES],
    queryFn: async () => {
      let url = "/cheer-message/student";
      if (loginType === "guardian") {
        url = "/cheer-message/guardian";
      }

      return await request<StudentCheerMessage[]>({
        method: "GET",
        url: url,
      });
    },
  });

  if (isFetching) {
    return <Loading />;
  }

  return (
    <MainTemplate nav={true} subPage={true} menuBtn={true} pageTitle="응원하기">
      <>
        {cheerMessages && cheerMessages.length > 0 ? (
          <CommentList data={cheerMessages} />
        ) : (
          <AlertText
            mainText="응원 메시지를 작성해주세요."
            subText={
              <>
                아직 학생을 연결하지 않았다면,
                <br />
                '설정' &gt; '법정보호자 연결 설정'에서 연결할 수 있습니다.
              </>
            }
          />
        )}
        <FloatingButton
          nav={true}
          icon={<IconWrite width={28} height={28} />}
          onClick={() => navigate("/comment/write")}
        />
      </>
    </MainTemplate>
  );
};
